import React, { useState } from "react";

const AssessmentBox = () => {
  const [isMandatoryOpen, setIsMandatoryOpen] = useState(false);
  const [isSpecializedOpen, setIsSpecializedOpen] = useState(false);

  const toggleMandatory = () => setIsMandatoryOpen(!isMandatoryOpen);
  const toggleSpecialized = () => setIsSpecializedOpen(!isSpecializedOpen);

  return (
    <div className=" max-w-7xl mx-auto py-8 px-4 md:py-12 md:px-16">
      {/* Main Heading */}
      <h2 className="text-2xl md:text-3xl font-semibold text-center mb-4">
        About This <span className="text-red-500">NVQ Assessment</span>
      </h2>
      {/* Description */}
      <p className="text-center text-gray-600 text-sm md:text-base mb-8">
        The Level 2 NVQ Diploma in Wood Occupations is designed for individuals
        working in wood-based trades within the construction industry, such as
        site carpentry, architectural joinery, or shopfitting. This
        qualification recognises the practical skills and knowledge required to
        carry out wood occupation tasks safely, accurately, and to industry
        standards.
      </p>
      {/* Subheading */}
      <h3 className="text-xl md:text-2xl font-medium text-center mb-6">
        About This NVQ Diploma Assessment
      </h3>
      {/* Dropdown Sections */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Mandatory Unit */}
        <div className=" rounded-xl ">
          <button
            className="w-full text-left p-4 bg-[#0C1524] text-white font-medium flex justify-between rounded-t-xl items-center"
            onClick={toggleMandatory}>
            Mandatory Unit
            <span>{isMandatoryOpen ? "˄" : "˅"}</span>
          </button>
          {isMandatoryOpen && (
            <div className="p-4 bg-[#2E3847] rounded-b-xl text-white">
              <ul className="list-disc list-inside">
                <li>
                  Conforming to general health, safety and welfare in the
                  workplace
                </li>
                <li>
                  Conforming to productive working practices in the workplace{" "}
                </li>
                <li>
                  Moving, handling and storing resources in the workplace{" "}
                </li>
              </ul>
            </div>
          )}
        </div>
        {/* Specialized Unit */}
        <div className=" rounded-xl ">
          <button
            className="w-full text-left p-4 bg-[#0C1524]  text-white font-medium flex justify-between rounded-t-xl items-center"
            onClick={toggleSpecialized}>
            Optional Units: (three optional units are required )
            <span>{isSpecializedOpen ? "˄" : "˅"}</span>
          </button>
          {isSpecializedOpen && (
            <div className="p-4 bg-[#2E3847] rounded-b-xl text-white">
              <ul className="list-disc list-inside">
                <li>Installing first fixing components in the workplace </li>
                <li>Installing second fixing components in the workplace </li>
                <li>
                  Erecting structural carcassing components in the workplace{" "}
                </li>
                <li>
                  Maintaining non-structural carpentry work in the workplace{" "}
                </li>
                <li>
                  Installing fire resisting timber door assemblies and doorsets
                  in the workplace{" "}
                </li>
                <li>
                  Setting up and using transportable cutting and shaping
                  machines in the workplace{" "}
                </li>
              </ul>
            </div>
          )}
          Note: The exact units may vary based on your specific role and
          endorsement.
        </div>
      </div>
    </div>
  );
};

export default AssessmentBox;
